import React from "react";
import { useAuthContext } from "../AuthenticationProvider";
import { Segment, Icon } from "semantic-ui-react";
import { RouteProps, Route, Redirect, useLocation } from "react-router-dom";
import * as Common from "../../utils/common.helpers";

export const AuthenticatedRoute: React.FC<RouteProps> = (props) => {
    const { loggedIn, loggingIn, initialized } = useAuthContext();
    const location = useLocation();

    if (loggedIn) {
        return <Route {...props} />;
    }

    if (!initialized && loggingIn) {
        return (
            <Segment placeholder textAlign="center" padded="very" className="fullpage_loading_segment">
                <p>
                    <Icon name="circle notched" loading /> Kirjaudutaan
                </p>
            </Segment>
        );
    }

    return <Redirect to={Common.makeLoginExpiredPageHref(location.pathname)} />;
};
